<template>
  <Listbox v-slot="{ open }" :disabled="false" class="group">
    <div class="relative w-fit">
      <ListboxButton
          :class="[
        open ? '!border-grays-800' : '',
        'relative cursor-pointer px-[12px] py-[7px] pr-[16px] flex flex-row-reverse items-center justify-between w-[188px] rounded bg-white border border-grays-400 text-left group hover:border-grays-600',
      ]"
      >
        <span
            :class="[
            open ? 'rotate-180 text-grays-800' : '',
            'material-symbols-rounded text-grays-700 group-disabled:text-grays-600 text-[20px]',
          ]"
        >expand_more</span>
        <div class="flex flex-row-reverse gap-[8px]">
          <span
              class="text-sm text-grays-900 group-disabled:text-grays-600 font-regular max-w-[130px] text-ellipsis overflow-hidden"
          >{{ getCurrentPhoneReminderText }}</span>
        </div>
      </ListboxButton>

      <transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
      >
        <ListboxOptions
            class="absolute flex flex-col gap-[4px] items-start pt-[12px] pb-[4px] px-[10px] mb-2 bottom-[40px] max-h-[400px] w-full overflow-auto rounded bg-white text-base shadow-tooltip"
        >
          <p class="text-grays-700 text-xs font-medium">
            מספרי טלפון רשומים במערכת
          </p>
          <div class="flex flex-col items-start">
            <check-box v-model="copyRemindAllPhones" class="h-[44px]" @input="handleRemindAllPhones">
              <slot>לכל המספרים</slot>
            </check-box>
            <div v-for="(phone) in copyPhones" :key="phone.tel">
              <check-box-by-numbers
                  v-if="phone.tel !== ''"
                  v-model="phone.no_msg"
                  :checked="phone.no_msg === 0"
                  :phone="phone"
                  class="h-[44px]"
                  @checkbox-triggered="handleCheckbox(phone)"
              >
                <slot>{{ phone.tel }}</slot>
              </check-box-by-numbers>
            </div>
          </div>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import {Listbox, ListboxButton, ListboxOptions} from "@headlessui/vue";
import CheckBoxByNumbers from "@/components/Global/CheckBoxByNumbers.vue";
import CheckBox from "@/components/Global/CheckBox.vue";

export default {
  name: "DropdownReminders",
  components: {
    CheckBox,
    CheckBoxByNumbers,
    Listbox,
    ListboxButton,
    ListboxOptions,
  },
  props: {
    phones: {
      type: Array,
      required: true,
    },
    remindAllPhones: {
      type: Boolean,
      required: true,
    },
    selectedPhones: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      copyRemindAllPhones: this.remindAllPhones ? 1 : 0,
    };
  },
  methods: {
    handleCheckbox(phone) {
      this.$emit("update-phones-reminds", phone);
    },
    handleRemindAllPhones() {
      this.$emit("update-all-phone-numbers-to-remind", this.copyRemindAllPhones);
    },
    checkAllPhonesStatus() {
      const allChecked = this.phones.every(phone => phone.no_msg === 0);
      this.copyRemindAllPhones = allChecked ? 1 : 0;
    },
  },
  computed: {
    copyPhones() {
      return [...this.phones];
    },
    getCurrentPhoneReminderText() {
      if (this.copyRemindAllPhones) {
        return "כל המספרים";
      } else if (this.selectedPhones.length === 0) {
        return "No phone";
      } else {
        return this.selectedPhones.join(',');
      }
    },
  },
  watch: {
    phones: {
      handler() {
        this.checkAllPhonesStatus();
      },
      immediate: true,
    },
    selectedPhones: {
      handler() {
        this.copyRemindAllPhones = !(this.selectedPhones.length === this.phones.length) ? 0 : 1
      },
      immediate: true,
      deep: true
    }
  },
};
</script>
